interface LogoProps {
    className?: string;
    short?: boolean;
}

export const Logo = ({ className = "", short = false }: LogoProps) => {
    const imageUrl = short ? "/images/logo_short.png" : "/images/logo.png";

    return (
        <div
            role="img"
            aria-label="Vigepra"
            className={`relative shrink-0 bg-[#a93c41] dark:bg-[#f19a9d] ${className.replace("object-contain", "")}`}
            style={{
                WebkitMask: `url(${imageUrl}) no-repeat center / contain`,
                mask: `url(${imageUrl}) no-repeat center / contain`,
            }}
        >
            <img
                src={imageUrl}
                alt=""
                aria-hidden="true"
                className="pointer-events-none h-full w-full object-contain opacity-0"
            />
        </div>
    );
};
